import { CContainer } from '@coreui/react';
import Loading from 'components/Loading';
import routesMap from 'layouts/routesMap';
import { trim } from 'lodash';
import React, { useMemo } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getStorageData, STORAGE_KEY } from 'utils/storage';
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';

interface Props {
  code?: string | null
}

const PrivateLayout: React.FC<Props> = (props) => {
  const isLogged = useMemo(() => {
    return Boolean(trim(getStorageData(STORAGE_KEY.ACCESS_TOKEN))) || !!props.code;
  }, [props.code]);

  return isLogged ? (
    <main>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <AppHeader />
        <div className="body flex-grow-1 px-3 bodyPage">
          <React.Suspense fallback={<Loading />}>
            <CContainer fluid className='mt-4'>
              <Outlet />
            </CContainer>
          </React.Suspense>
        </div>
      </div>
    </main>
  ) : (
    <Navigate to={routesMap.LOGIN} replace />
  );
};

export default PrivateLayout;
